module.exports = __webpack_public_path__ + "img/01.e6307ce2.jpg";